import { FilterCardEditorModalController } from './filter-card-editor-modal.component';

export class FilterCardEditorModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  open(model, filter, asNew) {
    let updateModalSize = () => {
      $('.modal-body1').height((window.innerHeight * 0.96 -
      $('.modal-header').outerHeight() -
      $('.modal-footer').outerHeight() - 30));
      let baseheight = $('.modal-body1').height() - $('#myTab').height() - 10;
      $('.aggregate-modal').height(baseheight);
      $('.dimension-list').height(baseheight);
      $('.aggregate-box').height(baseheight - 10);
      $('.filter-filters-list').height(baseheight - 10);
      $('.aggregate-container-modal')
        .height(baseheight - 10 - $('.aggregate-header').height());
    };

    this.modalInstance = this.$modal.open({
      template   : require('./filter-card-editor-modal.component.html'),
      controller : FilterCardEditorModalController,
      resolve    : {
        asNew : () => asNew,
        filter: () => filter,
        model : () => model,
      },
      windowClass: 'sc-filter-card-editor-modal',
    });
    this.modalInstance.opened
      .then(() => {
        this.$timeout(() => {
          updateModalSize();
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
    return this.modalInstance.result;
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/filter-card-editor-modal.service.js